import {
  message,
  PageHeader,
  Spin,
  Select,
  Row,
  Col,
  Input,
  Upload,
  Checkbox,
  Modal,
  Tooltip,
  Space,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  cuentaMask,
  DatePickerItem,
  round2Decimals,
  NotificacionPolizas,
  InputItem,
  ButtonItem,
  ErrorItem,
  SegmentedItem,
} from "../../../../Components/Items";
import { cuadrePorProyecto, mensajeDescuadrePorProyecto } from "../../../../Utils/cuadrePoliza";
import TotalesCuadrePoliza from "../../../../Components/TotalesCuadrePoliza";
import { PlusOutlined, DeleteOutlined, UploadOutlined, CopyOutlined } from "@ant-design/icons";
import moment from 'moment'
import AgregarTipoDePoliza from "../../TiposDePolizas/AgregarTipoDePoliza/AgregarTipoDePoliza";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import * as XLSX from 'xlsx'

const { Option } = Select;

const codigoCuentaContable = (value) =>
  value.nivel1 +
  (value.nivel2 ? "-" + value.nivel2 : "") +
  (value.nivel3 ? "-" + value.nivel3 : "") +
  (value.nivel4 ? "-" + value.nivel4 : "") +
  (value.nivel5 ? "-" + value.nivel5 : "");

class AgregarPoliza extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    todasTiposDePolizas: null,
    objetoTiposDePolizas: null,
    todasCuentaContable: null,
    objetoCuentaContable: null,
    todasBancos: null,
    modalAgregarTipoDePoliza: false,
    modalAgregarCuentaContable: false,
    filaCuentaContable: null,
    impuestos: [],
    proyectosConSubproyectos : false,
    objetoSubProyectos: null,
    // Modo "varios proyectos": cada renglon lleva su propio proyecto y cada proyecto tiene
    // que cuadrar por separado. El del encabezado pasa a ser el proyecto principal.
    multiProyecto: false,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await this.consultarCuentasContables();
    await axios
      .post(
        "bancos/selectBancos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancos: res.data });
        }
      });
    await axios
      .post(
        "tiposdepolizas/selectTiposDePolizas",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasTiposDePolizas: res.data });
          this.setState({
            objetoTiposDePolizas: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    if (this.props.location?.state?.id) {
      await axios
        .post(
          "polizas/datosPolizaManual",
          { empresaId: this.props.empresaId, polizaId: this.props.location?.state?.id },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.error("Error no se encontro informacion de la poliza");
          } else {
            // datosPolizaManual devuelve el CargoAbono completo, asi que los renglones ya
            // traen su proyectoId. Si son varios, la copia arranca en modo multi.
            const proyectosDistintos = new Set(
              (res.data.cargosAbonos || [])
                .filter(Boolean)
                .map((valueCA) => `${valueCA.proyectoId || ""}`)
            );
            const multiProyecto = proyectosDistintos.size > 1;
            this.setState({ multiProyecto });
            this.formRef.current.setFieldsValue({
              ...res.data,
            });
            if (!multiProyecto) this.onChangeProyecto(res.data.proyectoId);
          }
        });
    } else if (this.props.location?.state?.plantillaId) {
      await axios
        .post(
          "plantillasPolizas/datosPlantilla",
          { empresaId: this.props.empresaId, plantillaId: this.props.location?.state?.plantillaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.error("Error no se encontro informacion de la plantilla");
          } else {
            // PlantillaPoliza no guarda proyecto por renglon: todos heredan el de la plantilla,
            // si no, al cambiar a modo multi quedarian sin proyecto y el form no dejaria guardar.
            const plantilla = res.data.plantilla;
            this.formRef.current.setFieldsValue({
              ...plantilla,
              cargosAbonos: (plantilla.cargosAbonos || []).map((valueCA) =>
                valueCA
                  ? { ...valueCA, proyectoId: valueCA.proyectoId || plantilla.proyectoId }
                  : valueCA
              ),
            });
          }
        });
    }
    this.setState({ loading: false });
  }
  async consultarCuentasContables() {
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCuentaContable: res.data });
          this.setState({
            objetoCuentaContable: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
  }
  atras() {
    this.props.history.goBack();
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if(!values.cargosAbonos){
      message.error(
            "No hay cargos y abonos"
          );
      return;
    }
    // Con varios proyectos no basta con que el total global cuadre: cada proyecto tiene que
    // cuadrar por su cuenta, que es lo que da por hecho el desglose del PDF.
    const grupos = cuadrePorProyecto(values.cargosAbonos, values.proyectoId)
    if (this.state.multiProyecto) {
      const mensaje = mensajeDescuadrePorProyecto(grupos, this.nombreProyecto.bind(this))
      if (mensaje) return message.error(mensaje)
    } else {
      const total = grupos.reduce((suma, grupo) => round2Decimals(suma + grupo.diferencia), 0)
      if (Math.abs(total) !== 0) return message.info('Los cargos y abonos deben coincidir')
    }
    this.setState({ loading: true });
    axios
      .post(
        "polizas/agregarPolizaManual",
        {
          ...values,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se ha registrado una poliza"
          );
          NotificacionPolizas(res.data.polizasId)
          this.formRef.current.resetFields();
          this.atras(res.data.codigo);
        } else if (res.data.success === 1) {
          message.error(res.data.mensaje || "No se puede registrar la poliza");
        } else {
          message.error("Hubo un error y la poliza no se registro");
        }
      });
  }
  abrirAgregarTipoDePoliza() {
    this.setState({ modalAgregarTipoDePoliza: true });
  }
  cerrarAgregarTipoDePoliza(codigo) {
    this.setState({ modalAgregarTipoDePoliza: false });
    this.consultarTodo();
  }
  abrirAgregarCuentaContable(arrayKey) {
    this.setState({ modalAgregarCuentaContable: true, filaCuentaContable: arrayKey });
  }
  cerrarAgregarCuentaContable(codigo) {
    const filaCuentaContable = this.state.filaCuentaContable;
    this.setState({ modalAgregarCuentaContable: false, filaCuentaContable: null });
    this.consultarCuentasContables().then(() => {
      if (typeof codigo === "string" && filaCuentaContable !== null) {
        const cargosAbonos = this.formRef.current.getFieldValue("cargosAbonos") || [];
        cargosAbonos[filaCuentaContable] = {
          ...cargosAbonos[filaCuentaContable],
          cuentaContableId: codigo,
        };
        this.formRef.current.setFieldsValue({ cargosAbonos });
      }
    });
  }

  async onChangeArchivo(e) {
    this.setState({ loading: true })
    await this.formRef.current.validateFields().then(() => {
      if (e.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.setState({ archivosExcel: [{ ...e.file, name: e.file.name, status: 'uploading', response: 'Cargando', }], arhcivo: e.file });
        this.cargarArchivoExcel(e.file)
      } else {
        message.error('El archivo debe ser un archivo de excel')
        this.setState({ loading: false })
      }
    }).catch((error) => {
      message.error('Complete los campos requeridos antes de cargar el archivo')
      this.setState({ loading: false })
    })
  }

  cargarArchivoExcel(file) {
    let hojas = [];
    let reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onloadend = (e) => {
      let data = new Uint8Array(e.target.result)
      let workbook = XLSX.read(data, { type: 'array' })

      workbook.SheetNames.forEach((sheetName) => {
        let Xl_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
        hojas.push({
          data: Xl_row_object,
          sheetName
        })
      })
      let hoja1 = hojas[0].data
      this.archivoVerificar(hoja1).then((dataReturn) => {
        if (dataReturn.errores === 0) {
          this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success' }] });
          this.formRef.current.setFieldsValue({
            cargosAbonos: dataReturn.objeto,
          })
        } else {
          this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success', response: 'Con errores', }], archivoError: dataReturn.archivoErrores });
          this.formRef.current.setFieldsValue({
            cargosAbonos: dataReturn.objeto,
          })
          message.error('Se han detectado ' + dataReturn.errores + ' errores')
          message.info('Se se importan solo se importaran los campos correctos: ' + Number(hoja1.length - dataReturn.filaErrores))
        }
        this.setState({ loading: false })
      })
    }
  }

  async archivoVerificar(data) {
    let errores = 0
    let filaErrores = 0
    let mensaje = []
    const archivoEditar = XLSX.utils.book_new()
    const arrayErrores = []
    let objeto = []

    await Promise.all(data.map(async (data, index) => {
      let mensajeErrores = null
      let erroresFila = 0
      let fila = data['__rowNum__'] + 1
      let cuentaCont = data['Cuenta Contable'] ? `${data['Cuenta Contable']}`.trim() : undefined
      let cargo = data['Cargo']
      let abono = data['Abono']
      let concepto = data['Concepto'] ? `${data['Concepto']}`.trim() : undefined
      let proyecto = data['Proyecto'] ? `${data['Proyecto']}`.trim() : undefined
      const checarQueSeaNumero = (valor, nombreCampo) => {
        if (valor !== '' && valor !== undefined) {
          if (isNaN(valor) === true) {
            errores += 1
            erroresFila += 1
            mensaje.push(`${nombreCampo} fila: ${fila} no es un numero`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es un numero` : `${nombreCampo} no es un numero`
          }
        }
      }
      const queEste = (valor, nombreCampo) => {
        if (valor === '' || valor === undefined) {
          errores += 1
          erroresFila += 1
          mensaje.push(`${nombreCampo} fila: ${fila} esta vacio`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} esta vacio` : `${nombreCampo} esta vacio`
        }
      }
      const queSeaStringValido = (valor, nombreCampo) => {
        const patron = /^[A-Za-z0-9\n.: ,"'´`¨=ø$#°ºªáÁéÉíÍóÓúÚüÜñÑ@_/*+%&()!-_{¼³\u00A0]*$/
        if (valor !== '' && valor !== undefined) {
          if (!patron.test(valor)) {
            errores += 1
            erroresFila += 1
            mensaje.push(`${nombreCampo} fila: ${fila} no es un valor acceptado`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es un valor acceptado` : `${nombreCampo} no es un valor acceptado`
          }
        }
      }
      queEste(cuentaCont, 'Cuenta Contable')
      checarQueSeaNumero(cargo, 'Cargo')
      checarQueSeaNumero(abono, 'Abono')
      queSeaStringValido(concepto, 'Concepto')

      let cuentaContableId

      const encontrarCuentaContable = this.state.todasCuentaContable.find((value) => {
        return codigoCuentaContable(value) === cuentaCont
      })
      if (!encontrarCuentaContable) {
        errores += 1
        erroresFila += 1
        mensaje.push(`Cuenta Contable fila: ${fila} no existe`)
        mensajeErrores = mensajeErrores ? mensajeErrores + `, Cuenta Contable no existe` : `Cuenta Contable no existe`
      } else {
        cuentaContableId = encontrarCuentaContable._id
      }

      // La columna Proyecto es opcional: sin ella el renglon se queda con el proyecto del
      // encabezado, que es lo unico que existia antes del modo "varios proyectos".
      let proyectoId = this.formRef.current.getFieldValue("proyectoId")

      if (proyecto) {
        const encontrarProyecto = (this.state.todasProyectos || []).find(
          (value) => `${value.nombre}`.trim().toLowerCase() === proyecto.toLowerCase()
        )
        if (!encontrarProyecto) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Proyecto fila: ${fila} no existe`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Proyecto no existe` : `Proyecto no existe`
        } else {
          proyectoId = encontrarProyecto._id
        }
      }

      if (erroresFila === 0) {
        //   const encontrarCuentaContable2 = this.state.todasCuentaContable.find((value) => {
        //     return value.nivel1 + (value.nivel2 ? "-" + value.nivel2 : "") + ( value.nivel3 ? "-" + value.nivel3 : "") + ( value.nivel4 ? "-" + value.nivel4 : "") + ( value.nivel5 ? "-" + value.nivel5 : "") === ""
        // })
        objeto.push({
          cargo: cargo,
          abono: abono,
          concepto: concepto,
          cuentaContableId: cuentaContableId,
          proyectoId: proyectoId,
        })
      } else {
        arrayErrores.push({
          'Errores': mensajeErrores,
          'Fila archivo inicial': fila,
          ...data,
        })
        filaErrores += 1
      }
      return null
    }))
    const hoja = XLSX.utils.json_to_sheet(arrayErrores)
    XLSX.utils.book_append_sheet(archivoEditar, hoja, 'Hoja Errores')
    return { objeto: objeto, errores: errores, filaErrores, mensaje: mensaje, archivoErrores: archivoEditar }
  }

  descargarPlantillaPolizas() {
    const todasCuentaContable = this.state.todasCuentaContable || [];

    const cuentaEjemplo = (index) =>
      todasCuentaContable[index]
        ? codigoCuentaContable(todasCuentaContable[index])
        : "";

    const todasProyectos = this.state.todasProyectos || [];
    const proyectoEjemplo = (index) => todasProyectos[index]?.nombre || "";

    const wb = XLSX.utils.book_new();

    // La columna Proyecto es opcional: vacia, el renglon toma el proyecto del encabezado.
    // Sirve para capturar de un jalon una poliza repartida entre varios proyectos.
    const ws1 = XLSX.utils.aoa_to_sheet([
      ["Cuenta Contable", "Proyecto", "Cargo", "Abono", "Concepto"],
      [cuentaEjemplo(0), proyectoEjemplo(0), 1000, "", "Ejemplo de cargo"],
      [cuentaEjemplo(1), proyectoEjemplo(0), "", 1000, "Ejemplo de abono"],
    ]);
    XLSX.utils.book_append_sheet(wb, ws1, "Poliza");

    const cuentasData = todasCuentaContable.map((value) => ({
      "Cuenta Contable": codigoCuentaContable(value),
      Descripcion: value.descripcion,
    }));
    const ws2 = XLSX.utils.json_to_sheet(cuentasData);
    XLSX.utils.book_append_sheet(wb, ws2, "Cuentas Contables");

    const proyectosData = todasProyectos.map((value) => ({
      Proyecto: value.nombre,
      Descripcion: value.descripcion,
    }));
    const ws3 = XLSX.utils.json_to_sheet(proyectosData);
    XLSX.utils.book_append_sheet(wb, ws3, "Proyectos");

    XLSX.writeFile(wb, "plantillaPolizas.xlsx");
  }

  descargarArchivoErrores() {
    let wbout = XLSX.write(this.state.archivoError, { bookType: 'xlsx', type: 'binary' });
    const s2ab = (s) => {
      let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf);  //create uint8array as viewer
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
      return buf;
    }
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" })
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'errores.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  onChangeProyecto(value){
    // Con varios proyectos el subproyecto del encabezado no aplica.
    if (this.state.multiProyecto) {
      this.setState({ proyectosConSubproyectos: false, objetoSubproyectos: [] });
      return;
    }
    const proyecto = this.state.todasProyectos?.find(
      (valueP) => valueP._id === value
    );
    if (
      proyecto &&
      Array.isArray(proyecto.subProyectos) &&
      proyecto?.subProyectos?.length > 0
    ) {
      this.setState({
        proyectosConSubproyectos: true,
        objetoSubproyectos: proyecto.subProyectos.map((value) => (
          <Option key={value._id} value={value._id}>
            {value.codigo + " - " + value.nombre}
          </Option>
        )),
       
      });
    }
    else{
      this.setState({
        proyectosConSubproyectos: false,
        objetoSubproyectos: []
      })
    }
  }

  // Nombre para el desglose y los mensajes de error.
  nombreProyecto(proyectoId) {
    const proyecto = this.state.todasProyectos?.find(
      (valueP) => valueP._id === proyectoId
    );
    return proyecto?.nombre || "Sin proyecto";
  }

  // Renglones nuevos, nunca el mismo array: setFieldsValue con la misma referencia no
  // notifica a los shouldUpdate de la tabla y la columna se queda en blanco.
  // Con forzar en false el renglon conserva el suyo y solo se rellenan los vacios.
  reescribirProyectoRenglones(proyectoId, forzar) {
    const cargosAbonos = this.formRef.current.getFieldValue("cargosAbonos") || [];
    return cargosAbonos.map((valueCA) =>
      valueCA
        ? { ...valueCA, proyectoId: forzar ? proyectoId : valueCA.proyectoId || proyectoId }
        : valueCA
    );
  }

  cambiarModoProyecto(valor) {
    const multiProyecto = valor === 1;

    const proyectoId = this.formRef.current.getFieldValue("proyectoId");

    if (multiProyecto) {
      // El subproyecto pertenece a un proyecto: con varios ya no hay uno solo al que
      // referirse. Va null explicito para que el backend lo limpie.
      this.formRef.current.setFieldsValue({
        cargosAbonos: this.reescribirProyectoRenglones(proyectoId, false),
        subProyectoId: null,
      });
      this.setState({ multiProyecto: true, proyectosConSubproyectos: false });
      return;
    }

    const cargosAbonos = this.formRef.current.getFieldValue("cargosAbonos") || [];
    const proyectosDistintos = new Set(
      cargosAbonos.filter(Boolean).map((valueCA) => valueCA.proyectoId)
    );

    const volverASimple = () => {
      this.formRef.current.setFieldsValue({
        cargosAbonos: this.reescribirProyectoRenglones(proyectoId, true),
      });
      // El callback importa: onChangeProyecto se sale temprano si lee multiProyecto en true.
      this.setState({ multiProyecto: false }, () => this.onChangeProyecto(proyectoId));
    };

    if (proyectosDistintos.size > 1) {
      Modal.confirm({
        title: "Regresar a un solo proyecto",
        content:
          "Los renglones tienen proyectos distintos. Todos van a pasar al proyecto del encabezado.",
        okText: "Continuar",
        cancelText: "Cancelar",
        onOk: volverASimple,
      });
      return;
    }

    volverASimple();
  }

  // El concepto del encabezado casi siempre se repite en cada movimiento, asi que este boton
  // lo copia de un jalon en vez de teclearlo renglon por renglon.
  copiarConceptoATodos() {
    const concepto = this.formRef.current.getFieldValue("concepto");
    if (!concepto) return message.info("Primero captura el concepto de la poliza");

    const cargosAbonos = this.formRef.current.getFieldValue("cargosAbonos") || [];
    if (cargosAbonos.length === 0) return message.info("No hay cargos y abonos");

    // Renglones nuevos, nunca el mismo array: setFieldsValue con la misma referencia no
    // notifica a los shouldUpdate de la tabla y la columna se queda en blanco. Los renglones
    // recien agregados valen undefined hasta que se teclea algo, de ahi el objeto nuevo.
    const copiar = () => {
      this.formRef.current.setFieldsValue({
        cargosAbonos: cargosAbonos.map((valueCA) =>
          valueCA ? { ...valueCA, concepto } : { concepto }
        ),
      });
      message.success("Concepto copiado a " + cargosAbonos.length + " movimientos");
    };

    // Solo se pregunta cuando hay conceptos distintos capturados a mano, que es lo unico
    // que se perderia.
    const pisaCapturados = cargosAbonos.some(
      (valueCA) => valueCA?.concepto && valueCA.concepto !== concepto
    );
    if (pisaCapturados) {
      return Modal.confirm({
        title: "Copiar el concepto a todos los movimientos",
        content: "Hay renglones con un concepto distinto y se va a reemplazar.",
        okText: "Continuar",
        cancelText: "Cancelar",
        onOk: copiar,
      });
    }

    copiar();
  }

  // Las columnas se arman en cada render: TabbedDynamicTable no memoiza nada, y la de
  // Proyecto solo existe en modo multi. El numero de columnas tiene que empatar con el de
  // <td> de renderCargoAbonoRow en las dos ramas, porque la alineacion es posicional.
  getCargosAbonosColumns() {
    const multi = this.state.multiProyecto;
    const columnas = [
      { title: "Cuenta Contable", width: multi ? "19%" : "24%" },
      { title: "Cargo", width: multi ? "13%" : "17%" },
      { title: "Abono", width: multi ? "13%" : "17%" },
      { title: "Concepto", width: multi ? "21%" : "24%" },
      { title: "Acciones", width: "18%" },
    ];
    if (multi) columnas.splice(1, 0, { title: "Proyecto", width: "16%" });
    return columnas;
  }

  renderCargoAbonoRow({ key, name, fieldKey: _fieldKey, restField, arrayKey, remove }) {
    return (
      <tr key={key}>
        <td className="td-border">
          <Input.Group compact style={{ display: "flex" }}>
            <FormItem
              {...restField}
              name={[name, "cuentaContableId"]}
              fieldKey={[arrayKey, "cuentaContableId"]}
              required
              noStyle
            >
              <SelectItem
                sinBorde
                autoFocus
                style={{ flex: 1, minWidth: 0 }}
                placeholder="Cuenta"
              >
                {this.state.objetoCuentaContable}
              </SelectItem>
            </FormItem>
            {/* Ancho fijo en px, no en %: con 15% de una celda angosta el icono no cabia.
                La clase le devuelve el tamaño que `.tabla-compacta td *` le quita. */}
            {this.props.permisoAgregarCuentaContable && (
              <ButtonItem
                blanco
                className="boton-icono-celda"
                icon={<PlusOutlined />}
                style={{ width: 34 }}
                onClick={() => this.abrirAgregarCuentaContable(arrayKey)}
              />
            )}
          </Input.Group>
        </td>
        {this.state.multiProyecto && (
          <td className="td-border">
            <FormItem
              shouldUpdate={(prev, curr) => prev.proyectoId !== curr.proyectoId}
              noStyle
            >
              {({ getFieldValue }) => (
                <FormItem
                  {...restField}
                  name={[name, "proyectoId"]}
                  fieldKey={[arrayKey, "proyectoId"]}
                  required
                  noStyle
                  initialValue={getFieldValue("proyectoId")}
                >
                  <SelectItem
                    sinBorde
                    width="100%"
                    placeholder="Proyecto"
                  >
                    {this.state.objetoProyectos}
                  </SelectItem>
                </FormItem>
              )}
            </FormItem>
          </td>
        )}
        <td className="td-border">
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const arrayCargosAbonos = getFieldValue('cargosAbonos')
              const disabled = arrayCargosAbonos[arrayKey] ? arrayCargosAbonos[arrayKey].abono : false
              return (
                <FormItem
                  {...restField}
                  name={[name, "cargo"]}
                  fieldKey={[arrayKey, "cargo"]}
                  required={!disabled}
                  number
                  noStyle
                  initialValue={undefined}
                >
                  <InputNumberItem sinBorde disabled={disabled} dinero />
                </FormItem>
              )
            }}
          </FormItem>
        </td>
        <td className="td-border">
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const arrayCargosAbonos = getFieldValue('cargosAbonos')
              const disabled = arrayCargosAbonos[arrayKey] ? arrayCargosAbonos[arrayKey].cargo : false
              return (
                <FormItem
                  {...restField}
                  name={[name, "abono"]}
                  fieldKey={[arrayKey, "abono"]}
                  required={!disabled}
                  number
                  noStyle
                  initialValue={undefined}
                >
                  <InputNumberItem sinBorde disabled={disabled} dinero />
                </FormItem>
              )
            }}
          </FormItem>
        </td>
        <td className="td-border">
          <FormItem
            {...restField}
            name={[name, "concepto"]}
            fieldKey={[arrayKey, "concepto"]}
            required
            noStyle
          >
            <InputItem sinBorde />
          </FormItem>
        </td>
        {/* El cheque vivia en su propia columna, que no tenia <th>: la tabla traia 5
            encabezados y 6 celdas. Ahora comparte la de Acciones con el boton de borrar. */}
        <td className="td-border-sin-right">
          <Row className="acciones-container">
            <Col span={24}>
              <Space
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                size={8}
              >
                <FormItem noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const cuentaContableId = getFieldValue([
                      "cargosAbonos",
                      arrayKey,
                      "cuentaContableId",
                    ]);
                    const banco = cuentaContableId
                      ? this.state.todasBancos?.find(
                          (tBanco) =>
                            tBanco.cuentaContableId?.toString() ===
                            cuentaContableId.toString()
                        )
                      : null;
                    if (!banco) return null;
                    const cheque = getFieldValue([
                      "cargosAbonos",
                      arrayKey,
                      "cheque",
                    ]);
                    let consecutivoCheque = banco?.consecutivoCheque;
                    if (!consecutivoCheque) consecutivoCheque = 1;
                    return (
                      <Space direction="vertical" size={0}>
                        <FormItem
                          {...restField}
                          name={[name, "cheque"]}
                          fieldKey={[arrayKey, "cheque"]}
                          valuePropName="checked"
                          noStyle
                        >
                          <Checkbox>Cheque</Checkbox>
                        </FormItem>
                        {cheque ? (
                          <div
                            style={{
                              marginTop: 4,
                              padding: "2px 6px",
                              background: "#e6f7ff",
                              border: "1px solid #91d5ff",
                              borderRadius: 4,
                              fontSize: 12,
                              color: "#0070b9",
                              fontWeight: 600,
                            }}
                          >
                            N°: {consecutivoCheque}
                          </div>
                        ) : null}
                      </Space>
                    );
                  }}
                </FormItem>
                <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                  <ButtonItem
                    rojo2
                    icon={<DeleteOutlined />}
                    onClick={() => remove(name)}
                    size="small"
                  />
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </td>
      </tr>
    );
  }

  getObservacionesConfig() {
    return {
      totales: (
        <FormItem noStyle shouldUpdate>
          {({ getFieldValue }) => (
            <TotalesCuadrePoliza
              cargosAbonos={getFieldValue("cargosAbonos")}
              proyectoId={getFieldValue("proyectoId")}
              multiProyecto={this.state.multiProyecto}
              nombreProyecto={this.nombreProyecto.bind(this)}
            />
          )}
        </FormItem>
      ),
    };
  }

  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Agregar Poliza"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            // Un solo elemento con key: el array suelto de tres sin key avisaba en cada
            // render. Space ademas mete el espaciado que el PageHeader no da por si solo.
            <Space key="extra-actions">
              {this.state.archivoError ? <ButtonItem onClick={this.descargarArchivoErrores.bind(this)} danger>Descargar Errores</ButtonItem> : null}
              <ButtonItem
                blanco
                disabled={!this.state.todasCuentaContable}
                onClick={this.descargarPlantillaPolizas.bind(this)}
              >
                Descargar Plantilla
              </ButtonItem>
              <Upload
                showUploadList={{
                  showRemoveIcon: false,
                  showPreviewIcon: false,
                }}
                fileList={this.state.archivosExcel}
                customRequest={this.onChangeArchivo.bind(this)}
                accept='.xlsx'
              >
                <ButtonItem icon={<UploadOutlined />}>Subir Excel</ButtonItem>
              </Upload>
            </Space>,
          ]}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarPoliza"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <GeneralFormLayout
                cards={[
                  {
                    title: "Datos Generales",
                    content: (
                      <Row gutter={[16, 0]}>
                        <Col span={12}>
                          <div style={{ marginBottom: 10 }}>
                            <SegmentedItem
                              options={[
                                { label: "Un proyecto", value: 0 },
                                { label: "Varios proyectos", value: 1 },
                              ]}
                              value={this.state.multiProyecto ? 1 : 0}
                              onChange={this.cambiarModoProyecto.bind(this)}
                            />
                          </div>
                          <FormItem
                            label={this.state.multiProyecto ? "Proyecto principal" : "Proyecto"}
                            name="proyectoId"
                            margin
                            required
                          >
                            <SelectItem placeholder="Proyecto" onChange={(value) => this.onChangeProyecto(value)}>
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                          {!this.state.multiProyecto && this.state.proyectosConSubproyectos && (
                            <FormItem shouldUpdate noStyle>
                              {({ getFieldValue }) => {
                                let proyectoId = getFieldValue("proyectoId");
                                if (!proyectoId) return null;
                                return (
                                  <FormItem
                                    label="Subproyecto"
                                    name="subProyectoId"
                                    margin
                                  >
                                    <SelectItem
                                      placeholder="Subproyecto"
                                      allowClear
                                    >
                                      {this.state.objetoSubproyectos}
                                    </SelectItem>
                                  </FormItem>
                                );
                              }}
                            </FormItem>
                          )}
                          <FormItem
                            label="Tipo de Poliza"
                            margin
                          >
                            <Input.Group compact>
                              <FormItem name="tipoDePolizaId" required noStyle>
                                <SelectItem
                                  placeholder="Tipo de Poliza"
                                  width="80%"
                                >
                                  {this.state.objetoTiposDePolizas}
                                </SelectItem>
                              </FormItem>
                              <ButtonItem
                                blanco
                                icon={<PlusOutlined />}
                                style={{ width: "20%" }}
                                onClick={this.abrirAgregarTipoDePoliza.bind(this)}
                              />
                            </Input.Group>
                          </FormItem>
                        </Col>
                        <Col span={12}>
                          <FormItem
                            label="Fecha de Poliza"
                            name="fechaPoliza"
                            required
                            margin
                            initialValue={moment()}
                          >
                            <DatePickerItem
                              placeholder="Fecha de Poliza"
                              allowClear={false}
                            />
                          </FormItem>
                          <FormItem label="Concepto" margin>
                            <Input.Group compact>
                              <FormItem
                                name="concepto"
                                pattern
                                required
                                noStyle
                              >
                                <InputItem placeholder="Concepto" width="80%" />
                              </FormItem>
                              <Tooltip title="Copiar el concepto a todos los movimientos">
                                <ButtonItem
                                  blanco
                                  icon={<CopyOutlined />}
                                  style={{ width: "20%" }}
                                  onClick={this.copiarConceptoATodos.bind(this)}
                                />
                              </Tooltip>
                            </Input.Group>
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                ]}
                tabsConfig={{
                  tabs: [
                    {
                      key: "cargosAbonos",
                      label: "Cargos y Abonos",
                      listName: "cargosAbonos",
                      minWidth: this.state.multiProyecto ? "1100px" : "900px",
                      columns: this.getCargosAbonosColumns(),
                      renderRow: (rowProps) => this.renderCargoAbonoRow(rowProps),
                      renderFooter: ({ add }) => (
                        <FormItem noStyle>
                          <ButtonItem
                            type="primary"
                            cyan
                            block
                            hotkey="alt+a"
                            style={{ marginTop: 10 }}
                            icon={<PlusOutlined />}
                            onClick={() => add()}
                          >
                            Agregar Campo
                          </ButtonItem>
                        </FormItem>
                      ),
                    },
                  ],
                }}
                observacionesConfig={this.getObservacionesConfig()}
                totalesMaxWidth={this.state.multiProyecto ? "70%" : "35%"}
                actionButtons={
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    cyanB
                    hotkey="shift+a"
                    style={{ width: "5%" }}
                  >
                    Agregar
                  </ButtonItem>
                }
              />
            </Form>
          </Spin>
        </div>
        <AgregarTipoDePoliza
          visible={this.state.modalAgregarTipoDePoliza}
          cerrarAgregarTipoDePoliza={this.cerrarAgregarTipoDePoliza.bind(this)}
        />
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarCuentaContable: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cda85f30e81b54183cf9d")?.activado,
  };
};

export default connect(mapStateToProps)(AgregarPoliza);
